import { Component, Input } from '@angular/core';
import { Role } from 'src/app/classes/auth/role.class';
import { Functionalities } from 'src/app/services/auth/functionalities';

@Component({
    selector: 'app-user-role-descriptions',
    standalone: false,
    templateUrl: './user-role-descriptions.component.html',
    styleUrl: './user-role-descriptions.component.scss',
})
export class UserRoleDescriptionsComponent {
    @Input() roles: Role[] = [];

    hasPlannableFunctionality(role: Role): boolean {
        return role.functionalities?.some(f => f.key === Functionalities.Plannable) ?? false;
    }
}
